import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { calendarActions } from '../../../store/calendar';

import FullCalendar from 'fullcalendar-reactwrapper';
import 'fullcalendar/dist/fullcalendar.min.css';
import '../../../assets/front/css/custom/calendar.css';

import preloader from '../../../assets/front/img/catWalk.gif';

class Calendar extends React.Component {

    componentDidMount() {
        this.props.getCalendar();
    }

    render() {
        //console.log(this.props.calendar);
        if (!this.props.calendar || this.props.calendar.length === 0) {
            return (
                <div className="text-center g-min-height-100 g-mt-170 g-mb-170">
                    <img src={preloader} alt="" />
                </div>
            )
        }

        return (
            <div className="container g-pt-30 g-pb-50">
                <div className="g-hidden-md-down">
                    <FullCalendar 
                        id="pcCalendar"
                        header={{
                            left: 'prev,next today myCustomButton',
                            center: 'title',
                            right: 'month,basicWeek,basicDay'
                        }}
                        locale="ko"
                        timeFormat="HH:mm"
                        displayEventEnd={true}
                        navLinks={false}
                        editable={false}
                        eventLimit={true}
                        events={this.props.calendar}
                        />
                </div>

                <div className="g-hidden-lg-up">
                    <FullCalendar
                        id="mobileCalendar"
                        header={{
                            left: 'prev,next today myCustomButton',
                            center: 'title',
                            right: 'month,basicWeek,basicDay'
                        }}
                        locale="ko"
                        timeFormat="HH:mm"
                        displayEventEnd={true}
                        navLinks={false}
                        editable={false}
                        eventLimit={true}
                        events={this.props.calendar}
                        defaultView={'basicWeek'}
                        />
                </div>


            </div>
        )
    }
}

export default connect(
    state => state.calendar,
    dispatch => bindActionCreators({ ...calendarActions }, dispatch)
)(withRouter(Calendar));


// WEBPACK FOOTER //
// ./src/pages/front/activity/calendar.js